<div *ngIf="lesson != null" class="container">
    <div class="error-msg">
        You don't have any assignments from <b>{{lesson.Name}}</b>. <br><br>
        Please contact the teacher that provided you the lesson link to get access to the assignment.
    </div>

    <div class="homepage-link">
        <button mat-raised-button (click)="goToHomepage()">Go to your homepage</button>
    </div>
</div>
<div *ngIf="receivedData == true && lesson == null" class="container">
    <div class="error-msg">
        You don't have any assignments from the link provided. <br><br>
        Please contact the teacher that provided you the lesson link to get access to the assignment.
    </div>

    <div class="homepage-link">
        <button mat-raised-button (click)="goToHomepage()">Go to your homepage</button>
    </div>
</div>
